export function formatNumber(value, numberLocale) {
  return value.toLocaleString(numberLocale);
}